export default __webpack_public_path__ + "static/media/carjoin2.d72b0f9e.png";